import React from 'react';

const About = () => {
  return (
    <div style={{ padding: '1rem' }}>
      <h1>About Miskatonic.Academy</h1>
      
      <p>
        Miskatonic.Academy is your AI-powered gaming companion, designed to enhance your 
        gaming experience with instant answers and support. This site and application 
        are dedicated to helping gamers get answers to questions that arise while gaming. 
        Whether you're looking for help getting set up for your first play or encountering 
        an edge case that would benefit from a rules review, this application is built to help.
      </p>

      <h2>About This Project: A Fusion of Passion and Technology</h2>
      
      <p>
        Gaming has been an integral part of the project creator's life since childhood.
        From playing games with grandparents to discovering Dungeons & Dragons in the mid-'80s,
        this journey as a gamer has evolved alongside the industry's incredible rise in popularity. 
        However, the passion extends beyond gaming—with a successful career as an I.T. 
        professional with deep appreciation for technology.
      </p>
      
      <p>
        This project represents a fusion of these two lifelong interests: an experiment to 
        challenge ourselves and continue learning the latest advancements in cloud computing 
        and artificial intelligence. Built on Amazon Web Services (AWS) and leveraging large 
        language models available through AWS Bedrock, this endeavor allows us to stay on 
        the cutting edge while creating something valuable for fellow gaming enthusiasts.
      </p>
      
      <p>
        While this project is already a rewarding learning experience, there's always more 
        to explore. As we refine the architecture, our focus is on implementing best 
        practices—from robust CI/CD pipelines to enhanced usage monitoring and security 
        measures. Technology evolves rapidly, and we're committed to ensuring that this 
        application grows with it.
      </p>

      <h2>A Continuous Learning Journey</h2>
      
      <p>
        Currently, this project remains a personal passion, running on a small scale where 
        costs are manageable without monetization. However, expanding it further will require 
        a sustainable model—one that respects user privacy and avoids intrusive data practices. 
        Our goal is to maintain transparency and trust while ensuring the longevity of this 
        application.
      </p>

      <h2>Development Status</h2>
      
      <p>
        While our primary careers remain our focus, we take great pride in contributing to 
        technology and the gaming community through this project. As such, this application 
        must remain a hobby and learning experience—meaning that updates may come gradually, 
        often during weekends or holidays when we have dedicated time for development.
      </p>
      
      <p>
        For those who find value in this project, we appreciate your patience and support. 
        This journey is one of technical curiosity and passion, and we look forward to its evolution.
      </p>

      <div style={{ marginTop: '2rem', fontStyle: 'italic' }}>
        <p>Built by gamers, for gamers.</p>
        <p>- The Miskatonic Academy Team</p>
      </div>
    </div>
  );
};

export default About;